import React, {useState, useRef, useEffect} from 'react'
import {FormikProvider, FieldArray} from 'formik'
import {Stack} from 'react-bootstrap'
import deleteIcon from '../../../../../_metronic/images/Trashdelete.svg'
import uploadIcon from '../../../../../_metronic/images/upload.svg'
import plusIcon from '../../../../../_metronic/images/smlplus-blue.svg'
import {alert} from '../../../../../utils/helper'
import Dropdown from '../../../../sharedComponent/Dropdown/Dropdown'
import UploadAgentCSV from '../../../../sharedComponent/UploadAgentCSV'
import {DownloadTemplate} from '../../../../sharedComponent/DownloadTemplate/DownloadTemplate'
import ToggleButton from '../../../../sharedComponent/ToggleButton'
import './AddAgent.css'

const getHeaderLabels = (activeStatus: boolean) => [
  {name: 'First Name', info: ''},
  {name: 'Last Name', info: ''},
  ...(!activeStatus
    ? [
        {
          name: 'User Name',
          info: 'Username must contain at least 7 characters, including one uppercase letter, one lowercase letter, and one number. (Example: TpvSolutions123)',
        },
        {
          name: 'Login Password',
          info: 'Password must contain at least 8 characters, including one uppercase letter, one lowercase letter, one number, and one symbol. (Example: TpvSolutions@123)',
        },
      ]
    : []),
  ...(activeStatus ? [{name: 'Email ID', info: ''}] : []),
  {name: 'Leader Code', info: ''},
  {name: 'Rep Id', info: ''},
]

const AddAgent = ({formik, setIsSubmit, activeStatus, setActiveStatus, setIsUploadMode}: any) => {
  const [manualAgent, setManualAgent] = useState(true)
  const [fileUploadErr, setFileUploadErr] = useState(false)
  const scrollEndRef = useRef<null | HTMLDivElement>(null)
  useEffect(() => {
    if (activeStatus) {
      formik.setFieldValue(
        'agent',
        formik.values.agent.map((agent: any) => ({
          ...agent,
          UserName: '',
          agentPassword: '',
        }))
      )
    } else {
      formik.setFieldValue(
        'agent',
        formik.values.agent.map((agent: any) => ({
          ...agent,
          agentEmailID: '',
        }))
      )
    }
  }, [activeStatus]) // eslint-disable-line react-hooks/exhaustive-deps

  const filterEmptyAgents = (agents: any) =>
    agents.filter(
      (agent: any) =>
        agent.agentFirstName ||
        agent.agentLastName ||
        agent.agentEmailID ||
        agent.agentLeaderCode ||
        agent.agentRepId
    )
  const headerLabels = getHeaderLabels(activeStatus)
  const isFunction = typeof setIsSubmit === 'function'
  return (
    <div>
      <FormikProvider value={formik}>
        <div>
          <FieldArray name='agent'>
            {({form: {values}, ...fieldArrayHelpers}) => {
              const onAddClick = (e: any) => {
                e.preventDefault()
                isFunction && setIsSubmit(true)
                fieldArrayHelpers.push({
                  id: values?.agent?.length,
                  agentFirstName: '',
                  agentLastName: '',
                  agentEmailID: '',
                  agentRepId: '',
                  agentLeaderCode: null,
                  UserName: '',
                  agentPassword: '',
                })
              }

              const onBulkUpload = (e: any) => {
                isFunction && setIsSubmit(false)
                setManualAgent(false)
                setIsUploadMode?.(true)
                formik.setFieldValue('agent', filterEmptyAgents(formik.values.agent))
                formik.setErrors({})
                e.preventDefault()
              }

              const makeManualView = (e: any) => {
                isFunction && setIsSubmit(true)
                formik.setFieldValue('agent', filterEmptyAgents(formik.values.agent))
                e.preventDefault()
                setManualAgent(true)
                setIsUploadMode?.(false)
              }

              return (
                <React.Fragment>
                  <Stack direction='horizontal' gap={3} className='mb-4'>
                    <h1 className='text-gray-800 fs-3 mb-0'>Agent List</h1>
                    <div className='agent-col-toggle'>
                      <ToggleButton
                        leftText='UserName flow'
                        rightText='Email flow'
                        leftTextClassName='badge-light-danger'
                        rightTextClassName='badge-light-success'
                        isActive={activeStatus}
                        onChange={() => setActiveStatus((prev: any) => !prev)}
                      />
                    </div>
                    <div className='ms-auto d-flex gap-3'>
                      <DownloadTemplate
                        href={
                          activeStatus
                            ? process.env.REACT_APP_AGENT_TEMPLATE_DOWNLOAD
                            : process.env.REACT_APP_AGENT_TEMPLATE_DOWNLOAD_USERID_PASSWORD
                        }
                        text='Download Template'
                      />
                      <button
                        className='btn btn-light-primary btn-active-light-primary'
                        onClick={onBulkUpload}
                      >
                        <img src={uploadIcon} alt='' className='svg-icon svg-icon-1' />
                        <span className='fw-bold fs-base'>Upload List</span>
                      </button>
                      {manualAgent ? (
                        <button
                          type='button'
                          className='btn btn-light-primary btn-active-light-primary'
                          onMouseDown={onAddClick}
                          onClick={() => scrollEndRef.current?.scrollIntoView({behavior: 'smooth'})}
                        >
                          <img src={plusIcon} alt='' className='svg-icon svg-icon-1' />
                          <span className='fw-bold fs-base'>Add Agent</span>
                        </button>
                      ) : (
                        <button
                          type='button'
                          className='btn btn-light-primary btn-active-light-primary'
                          onClick={makeManualView}
                        >
                          <img src={plusIcon} alt='' className='svg-icon svg-icon-1' />
                          <span className='fw-bold fs-base'>Add Agent</span>
                        </button>
                      )}
                    </div>
                  </Stack>
                  {manualAgent ? (
                    <div className='agent-table-container'>
                      <div
                        className={!activeStatus ? 'agent-header-row' : 'agent-header-row-email'}
                      >
                        {headerLabels.map((label, i) => (
                          <div key={i}>
                            <span className='fs-7 fw-semibold lh-23px'>{label.name}</span>
                            {label.info && (
                              <i
                                className='bi bi-info-circle ms-2 text-primary cursor-pointer'
                                onClick={() => alert(`${label.info}`, 'info')}
                              />
                            )}
                          </div>
                        ))}
                      </div>
                      <div className='agent-rows-wrapper'>
                        {values?.agent?.map(({id}: any, index: any) => (
                          <div
                            key={index}
                            className={!activeStatus ? 'agent-data-row' : 'agent-data-row-email'}
                          >
                            <div className='agent-col-field'>
                              <input
                                id={`agent-${id}-firstName`}
                                name={`agent.[${index}].agentFirstName`}
                                className='form-control form-control-lg form-control-solid'
                                {...formik.getFieldProps(`agent.[${index}].agentFirstName`)}
                                value={formik.values.agent[index].agentFirstName}
                                onChange={formik.handleChange}
                                placeholder='Enter first name'
                              />
                              <span className='text-danger agent-field-error'>
                                {Boolean(formik.errors?.agent) &&
                                  Boolean(formik.touched?.agent) &&
                                  formik.errors?.agent[index]?.agentFirstName}
                              </span>
                            </div>
                            <div className='agent-col-field'>
                              <input
                                id={`agent-${id}-lastName`}
                                name={`agent.[${index}].agentLastName`}
                                className='form-control form-control-lg form-control-solid'
                                {...formik.getFieldProps(`agent.[${index}].agentLastName`)}
                                value={formik.values.agent[index].agentLastName}
                                onChange={formik.handleChange}
                                placeholder='Enter last name'
                              />
                              <span className='text-danger agent-field-error'>
                                {Boolean(formik.errors?.agent) &&
                                  Boolean(formik.touched?.agent) &&
                                  formik.errors?.agent[index]?.agentLastName}
                              </span>
                            </div>
                            {!activeStatus && (
                              <div className='agent-col-field'>
                                <input
                                  id={`agent-${id}-userName`}
                                  name={`agent.[${index}].UserName`}
                                  className='form-control form-control-lg form-control-solid'
                                  {...formik.getFieldProps(`agent.[${index}].UserName`)}
                                  value={formik.values.agent[index].UserName}
                                  onChange={formik.handleChange}
                                  placeholder='Enter UserName'
                                  disabled={activeStatus}
                                  style={activeStatus ? {cursor: 'not-allowed'} : undefined}
                                />
                                <span
                                  className='text-danger agent-field-error text-ellipsis cursor-pointer'
                                  title={formik.errors?.agent?.[index]?.UserName}
                                >
                                  {Boolean(formik.errors?.agent) &&
                                    Boolean(formik.touched?.agent) &&
                                    formik.errors?.agent[index]?.UserName}
                                </span>
                              </div>
                            )}
                            {!activeStatus && (
                              <div className='agent-col-field'>
                                <input
                                  id={`agent-${id}-agentPassword`}
                                  name={`agent.[${index}].agentPassword`}
                                  className='form-control form-control-lg form-control-solid'
                                  {...formik.getFieldProps(`agent.[${index}].agentPassword`)}
                                  value={formik.values.agent[index].agentPassword}
                                  onChange={formik.handleChange}
                                  placeholder='Enter Password'
                                  disabled={activeStatus}
                                  style={activeStatus ? {cursor: 'not-allowed'} : undefined}
                                />
                                <span
                                  className='text-danger agent-field-error text-ellipsis cursor-pointer'
                                  title={formik.errors?.agent?.[index]?.agentPassword}
                                >
                                  {Boolean(formik.errors?.agent) &&
                                    Boolean(formik.touched?.agent) &&
                                    formik.errors?.agent[index]?.agentPassword}
                                </span>
                              </div>
                            )}
                            {activeStatus && (
                              <div className='agent-col-field'>
                                <input
                                  id={`agent-${id}-email`}
                                  name={`agent.[${index}].agentEmailID`}
                                  className='form-control form-control-lg form-control-solid'
                                  {...formik.getFieldProps(`agent.[${index}].agentEmailID`)}
                                  value={formik.values.agent[index].agentEmailID}
                                  onChange={formik.handleChange}
                                  placeholder='Enter Email ID'
                                  disabled={!activeStatus}
                                  style={!activeStatus ? {cursor: 'not-allowed'} : undefined}
                                />
                                <span className='text-danger agent-field-error'>
                                  {Boolean(formik.errors?.agent) &&
                                    Boolean(formik.touched?.agent) &&
                                    formik.errors?.agent[index]?.agentEmailID}
                                </span>
                              </div>
                            )}
                            <div>
                              <Dropdown
                                fieldName={`agent.[${index}].agentLeaderCode`}
                                optionList={formik.values?.agentLeaders?.map((leader: any) => ({
                                  id: leader.leaderCode,
                                  value: leader.leaderCode,
                                }))}
                                formik={formik}
                                selectedVal={formik.values.agent[index].agentLeaderCode}
                                handleSelectedItem={(e: any) =>
                                  formik.setFieldValue(`agent.[${index}].agentLeaderCode`, e.value)
                                }
                              />
                            </div>
                            <div className='agent-col-field'>
                              <input
                                id={`agent-${id}-repId`}
                                name={`agent.[${index}].agentRepId`}
                                className='form-control form-control-lg form-control-solid'
                                {...formik.getFieldProps(`agent.[${index}].agentRepId`)}
                                value={formik.values.agent[index].agentRepId}
                                onChange={formik.handleChange}
                                placeholder='Enter Rep ID'
                              />
                              <span className='text-danger agent-field-error'>
                                {Boolean(formik.errors?.agent) &&
                                  Boolean(formik.touched?.agent) &&
                                  formik.errors?.agent[index]?.agentRepId}
                              </span>
                            </div>
                            <div className='agent-col-delete'>
                              <button
                                type='button'
                                className='btn p-0'
                                onClick={() => fieldArrayHelpers.remove(index)}
                              >
                                <img src={deleteIcon} alt='delete icon' />
                              </button>
                            </div>
                          </div>
                        ))}

                        <div ref={scrollEndRef} className='agent-scroll-anchor mt-n3' />
                      </div>
                    </div>
                  ) : (
                    <UploadAgentCSV
                      setFileUploadErr={setFileUploadErr}
                      fileUploadErr={fileUploadErr}
                      arrayHelpers={fieldArrayHelpers}
                      setIsSubmit={setIsSubmit}
                      leaders={formik.values?.agentLeaders}
                      activeStatus={activeStatus}
                    />
                  )}
                </React.Fragment>
              )
            }}
          </FieldArray>
        </div>
      </FormikProvider>
    </div>
  )
}

export default AddAgent
